/**
 * PharmacyAutoRouter — mobile/tablet use unified CareFlow app; desktop keeps Pharmacy.
 */
import React from "react";
import { isMobile, isTablet } from "../../utils/device";
import Pharmacy from "../../pages/Pharmacy";
import FastBilling from "../../pages/FastBilling";

export default function PharmacyAutoRouter() {
  if (isMobile() || isTablet()) return <FastBilling />;
  return <Pharmacy />;
}
